import { render, staticRenderFns } from "./PagamentoTab.vue?vue&type=template&id=75e4b0fb"
import script from "./PagamentoTab.vue?vue&type=script&lang=js"
export * from "./PagamentoTab.vue?vue&type=script&lang=js"
import style0 from "./PagamentoTab.vue?vue&type=style&index=0&id=75e4b0fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports